import { Injectable, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';
import { KeysService } from './input-devices/keys.service';
import { EventInteraction } from '../dynamic/event.interaction.service';
import { Subscription } from 'rxjs/Subscription';
import { APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { InternalStateHelperService } from './internal-state/internal-state.helper.service';
import { KeysDefaultBehavior } from './input-devices/keys.default.behavior.service';

@Injectable()
export class UIStateEngine {
    private isBrowser: boolean;
    private KeyCode: any;
    private KeyMeta: any;
    private TraversalModes: any;
    private KeyConfig: any;
    private subscriptions: Array<Subscription> = [];
    private processingKey: boolean;
    private handlers: Array<any> = []
    public _navActive: boolean; //determines if nav should be shown opened when app starts
    private suspended: boolean;
    public keyRepeat: boolean;
    protected reinitFocus: boolean = false;

    public get navActive() {
        return this._navActive;
    }

    public setNavActive(){
        this._navActive = true;
        //this.setNavState(true);
    }

    public setNavInactive(){
        this._navActive = false;
        //this.setNavState(false);
    }

    private get allowMenuNavigation(): boolean {
        const history = this.getActivePathHistory();
        return !history || history.length < 1
    }

    public getPopState(){
        return this.stateHelper.getPopState();
    }

    constructor(
        protected router: Router,
        @Inject(PLATFORM_ID) platformId: string,
        @Inject(APP_SETTINGS) private settings: any,
        private keysService: KeysService,
        private eventInteraction: EventInteraction,
        private location: Location,
        private stateHelper: InternalStateHelperService,
        private keyBehavior: KeysDefaultBehavior
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.KeyCode = this.settings.KeyCode;
        this.KeyMeta = this.settings.KeyConfig;
        this.TraversalModes = this.settings.TraversalModes;
        this.KeyConfig = this.settings.KeyConfig;

        let navMenuConfig = this.settings["NAV_MENU_CONFIG"]
        if (navMenuConfig) {
            this._navActive = navMenuConfig.openOnStart
        }

        if (this.isBrowser) {
            const self = this;
            if (this.settings.ENABLE_KEY_REPEAT_SCROLLING){
                this.subscriptions.push(this.keysService.buttonRepeat$.subscribe(keyCode => {
                    this.keyRepeat = true;
                    if (keyCode > 36 && keyCode < 41){
                        this.processUIInteraction({ message: { keyCode: keyCode, source: '' } });
                    }
                }));
            }

            this.subscriptions.push(this.keysService.buttonReleased$.subscribe(keyCode => {
                if (!this.processingKey && !this.suspended) {
                    this.keyRepeat = false;
                    this.processingKey = true;
                    this.processUIInteraction({ message: { keyCode: keyCode, source: '' } });
                }
            }));
        }
    }

    //** ui interactions */
    // this.subscriptions.push(this.eventInteraction.subscribe(e => {
    //     if (e.key == "keyInteractionHandled") {
    //         this.processUIInteraction(e);
    //     }
    // }));

    processUIInteraction(e) {
        const keyCode = e.message.keyCode
        var result = false;

        // check if there are registered key handlers    
        result = this.tryHandlersProcessing(keyCode);
        if (!result) {
            result = this.handleKeyAppDefault(keyCode);
        }

        //if a key is handled successfully, stop processing
        if (result) {
            this.interactionCompleted();
            return;
        }


        if (this.allowMenuNavigation) {
            //    if (!this.contentHidden) {
            if (this.isMenuOpenKey(keyCode)) {
                // open nav Menu on Up or ESC keys
                // this.sideMenuService.Toggle(true);
                this._navActive = true;
                this.eventInteraction.next({ key: 'activeInteractionChanged', message: "menu" });
                this.setNavState(true);
            }
            else if (this._navActive && this.isMenuCloseNavKey(keyCode)) {
                this._navActive = false;
                this.eventInteraction.next({ key: 'activeInteractionChanged', message: "content" });
                this.setNavState(false);
            }
            //todo: overlay and other top-level content handling
        }
        else {
            //             if (keyCode === this.KeyCode.ESC) {
            //                 //todo: handle back navigation and/or menu logic
            //                 this.location.back();
            //             }
        }
        //}
        this.interactionCompleted();
    }

    handleAppBack(): boolean {
        return this.keyBehavior.handleAppBack();
    }

    private isMenuOpenNavKey(keyCode) {
        const menuMeta = this.settings['NAV_MENU_CONFIG'];
        if (keyCode == menuMeta['locationVal']) {
            return true;
        }
        else {
            return false;
        }
    }

    private isMenuCloseNavKey(keyCode) {
        const menuMeta = this.settings['NAV_MENU_CONFIG'];
        const oppKey = this.settings['OppositeNavKey'];
        if (keyCode == oppKey[String(menuMeta['locationVal'])]) {
            return true;
        }
        else {
            return false;
        }
    }

    private isMenuOpenEscKey(keyCode) {
        const menuMeta = this.settings['NAV_MENU_CONFIG'];
        if (keyCode === this.KeyCode.ESC && menuMeta['openOnEsc']) {
            return true;
        }
        return false;
    }

    private isMenuOpenKey(keyCode) {
        if (!this._navActive && ((this.isMenuOpenNavKey(keyCode)) || (this.isMenuOpenEscKey(keyCode)))) {
            return true;
        }
        else {
            return false;
        }
    }


    private handleKey(handler, keyCode, keyMeta?: any): boolean {
        if (!keyMeta) {
            keyMeta = this.KeyMeta[String(keyCode)];
        }
        if (handler[keyMeta.function_key]) {
            return handler[keyMeta.function_key](keyCode);
        }
        else {
            return this.keyBehavior[keyMeta.function_key](keyCode, handler);
        }
    }

    public handleDefaultKey(handler, keyCode, keyMeta?: any): boolean {
        if (!keyMeta) {
            keyMeta = this.KeyMeta[String(keyCode)];
        }
        return this.keyBehavior[keyMeta.function_key](keyCode, handler);
    }

    canProcessKey(keyCode, component) {
        // if (component.constructor.name != 'NavMenu' && !this._navActive){
        //     component.isActive = true;
        // }
        //         if (!component.keys || component.keys.length < 1){
        //             this.setSupportedKeys(component);
        //         }
        return component.isActive && component.keys.indexOf(keyCode) > -1;
        //return component.keys.indexOf(keyCode) > -1;
    }

    private handleKeyAppDefault(keyCode) {
        const keyMeta = this.KeyMeta[String(keyCode)];
        if (this.keyBehavior[keyMeta.app_key]) {
            return this.keyBehavior[keyMeta.app_key]();
        }
        return false;
    }

    private tryHandlersProcessing(keyCode) {
        var result = false;
        const keyMeta = this.KeyConfig[String(keyCode)];
        if (this.handlers.length > 0) {
            //iterate over handlers (test deep-most leaf first)
            for (var i = (this.handlers.length - 1); i >= 0; i--) {
                //this.handlers.reverse().forEach(handler => {
                let handler = this.handlers[i];
                // part of the registration process, allow interactive containers/components
                //to pass their 'keys' configuration: what keys they can respond to;
                //this way we can know right away if a key is capable of being handle by current handler, or if 
                //the next handler needs to be used.
                if (this.canProcessKey(keyCode, handler)) {
                    result = this.handleKey(handler, keyCode, keyMeta);
                    if (result || (!keyMeta.bubbles)) break;
                }
            };
        }
        return result;
    }

    interactionCompleted() {
        const delay = this.settings.KEY_PROCESSING_DELAY || 0;
        setTimeout(() => {
            this.processingKey = false;
        }, delay)
    }

    registerInteractiveHandler(handler) {
        if (this.handlers.indexOf(handler) < 0) {
            this.handlers.push(handler);
        }
    }

    setSupportedKeys(component) {
        switch (component.interactionMode) {
            case this.TraversalModes.Horizontal:
                component.keys = [this.KeyCode.LEFT, this.KeyCode.RIGHT]
                break;
            case this.TraversalModes.Vertical:
                component.keys = [this.KeyCode.UP, this.KeyCode.DOWN]
                break;
            case this.TraversalModes.Grid:
            case this.TraversalModes.Custom:
                component.keys = [this.KeyCode.UP, this.KeyCode.DOWN, this.KeyCode.LEFT, this.KeyCode.RIGHT]
                break;
        }

        if (component.interactionSelect) {
            component.keys.push(this.KeyCode.SELECT);
        }

        if (component.interactionBack) {// || this.isTraversalBack(component)) {
            component.keys.push(this.KeyCode.ESC);
        }
    }

    private isTraversalBack(component): boolean {
        const menuMeta = this.settings['NAV_MENU_CONFIG'];
        if (!component.interactionMode || component.interactionMode == this.TraversalModes.Custom) {
            return false;
        }
        if (component.interactionMode == this.TraversalModes.Grid) {
            return true;
        }
        if ((menuMeta.location == "LEFT" || menuMeta.location == "RIGHT") && component.interactionMode == this.TraversalModes.Horizontal) {
            return true;
        }
        if ((menuMeta.location == "UP" || menuMeta.location == "DOWN") && component.interactionMode == this.TraversalModes.Vertical) {
            return true;
        }
        return false;
    }

    restoreInternalState(component, url) {
        const currentState = this.stateHelper.getActivePath();
        if (currentState && currentState.urlKey != url) {
            const prevState = currentState['childrenState'][this['slug']];
            if (prevState) {
                component.focusedItemIndex = prevState['selectedItem'];
            }
        }
    }

    // registerInteractiveContainerHandler(handler) {
    //     //starts a new handler path
    //     //this.handlers = []
    //     this.handlers.push(handler);
    // }

    // registarInteractiveComponentHandler(handler) {
    //     this.handlers.push(handler);
    // }

    deregisterHandler(handler) {
        let index = this.handlers.indexOf(handler);
        if (index > -1) {
            this.handlers.splice(index, 1);
        }
    }

    public setActivePath(state: Object) {
        this.stateHelper.setActivePath(state);
    }

    public setDescendantSelected(slugIdentifier: string, selectedItem: number) {
        this.stateHelper.setDescendantSelected(slugIdentifier, selectedItem);
    }

    public getActivePath() {
        return this.stateHelper.getActivePath();
    }

    public wasPopped() {
        return this.stateHelper.wasPopped();
    }

    public popState(url) {
        return this.stateHelper.popState(url);
    }

    public addToHistory(entry?: any) {
        this.stateHelper.addToHistory(entry);
    }

    public setActivePathHistory(history: any) {
        this.stateHelper.setActivePathHistory(history);
    }

    public getActivePathHistory() {
        return this.stateHelper.getActivePathHistory();
    }

    public setRootPageState() {
        this.stateHelper.setRootPageState();
    }

    public resetRootPageState() {
        this.stateHelper.resetRootPageState();
    }
    public getRootPageState() {
        return this.stateHelper.getRootPageState();
    }

    public setPopState(url) {
        this.stateHelper.setPopState(url);
    }

    public setDescendantProp(slugIdentifier: string, propName: string, propVal: any) {
        this.stateHelper.setDescendantProp(slugIdentifier, propName, propVal);
    }

    public pop() {
        return this.stateHelper.pop();
    }

    public navigateAndReplaceStateWithPop(url) {
        this.pop();
        this.router.navigateByUrl(url, { replaceUrl: true });
    }

    public navigateAndReplaceState(url) {
        this.stateHelper.setHistoryReplaceFlag(true);
        this.router.navigateByUrl(url, { replaceUrl: true });
    }

    public adjustInScopeItems(component, index) {
        this.stateHelper.adjustInScopeItems(component, index);
    }

    // public handleFilterRowFocusChanged( component, previousFocusedItem ): void {
    //     this.stateHelper.handleFilterRowFocusChanged( component, previousFocusedItem );
    // }
    public setDescendantProps(slugIdentifier: string, changes: object, monitoredPropsMap: object) {
        let props = {};
        let effChanges = false;
        Object.keys(changes).forEach(function (key) {
            if (changes[key].currentValue !== changes[key].previousValue) {
                if (monitoredPropsMap[key] && slugIdentifier) {
                    effChanges = true;
                    props[monitoredPropsMap[key]] = changes[key].currentValue;
                }
            }
        });

        if (effChanges) {
            this.stateHelper.setDescendantProps(slugIdentifier, props);
        }
    }

    public getNavState() {
        return this.stateHelper.getNavState();
    }

    public setNavState(val: boolean) {
        this.stateHelper.setNavState(val);
    }

    public toggleInteractionSuspend(state) {
        this.suspended = state;
    }

    public adjustFlattenedRowItems(item: any, asyncResult: any, component: any, jumpToLoadedContent: boolean): void {
        this.stateHelper.adjustFlattenedRowItems(item, asyncResult, component, jumpToLoadedContent);
    }

    public setDefaultSelectedItem(component) {
        if (component.item) {
            if (component.data.length == 0) {
                component.data = (component.item && component.item.data) || [];
            }
            this.setFocusedItem(component);
        }
        else{
            if (component.data){
                //this.setFocusedItem(component);
            }
        }
    }

    private setFocusedItem(component){
        component.focusedItemIndex = 0;
        if (component.activeSlug) {
            const activeIndex = component.data.findIndex(i => i.meta.slug == component.activeSlug);
            if (activeIndex > -1) {
                component.focusedItemIndex = activeIndex;
            }
        }
        component.focusedItem = component.data.length > 0 && component.data[component.focusedItemIndex];
        if (!component.slug) component.slug = component.item.meta && component.item.meta.slug;
    }

    public restoreScrollPositionIfAvailable(component) {
        if (this.reinitFocus) return;

        const currentState = this.stateHelper.getActivePath();
        const routeUrl = (this.router.url == "/") ? "/home-ott" : this.router.url;
        if (currentState && currentState.urlKey == routeUrl) {
            const currentChildState = currentState['childrenState'][component.slug];
            if (currentChildState) {
                component.offsetScrollX = currentChildState['offsetScrollX'] || 0.0
                component.offsetScrollY = currentChildState['offsetScrollY'] || 0.0
                const indexToGo = (currentChildState['selectedItem']) ? currentChildState['selectedItem'] : 0;

                component.focusedItemIndex = indexToGo;
                component.focusedItem = component.data[component.focusedItemIndex];

                //this.isActive = (currentChildState['isActive']) ? currentChildState['isActive'] : false;                
                //this.changeHandlerState(this.isActive);
            }
        }
    }

    public addTheNextPage(component, spot){
        if (component.focusedItemIndex == (component.data.length - spot)){
            if (component.item.data.length < component.item.meta.total_count){
                //this.keysService.handleKeyUp(this);
                const newData = component.coreEffects.moreResultsBySearchTermAndCategory(component.item);   
                component.item['meta'] = newData['meta'];
                component.item['data'] = component.item['data'].concat(newData['data']);
                component.data = component.item['data'];
                component.ref.detectChanges();
            }
        }
    }

    public setScrollingOptions(component) {
        if (component.data && component.data.length > 0) {
            //parent component
            let targetElem = component.scrollElement || component.elem;
            component.renderer.addClass(targetElem.nativeElement, "scrollable");
        }

        component.numberOfRows = Math.ceil(component.data.length / component.maxPerRow);
    }

    public focusedItemChanged(component, targetElem) {
        if (component.isActive) {
            //checks if scrollable component has focus, otherwise it sends request to parent
            if (component.awaitRefocus || component.awaitRefocus === undefined) {
                if (component.onItemFocused.observers.length > 0) {
                    component.awaitRefocus = false;
                    component.onItemFocused.next(targetElem);
                    return;
                }
            }

            //horizontal scrollable component process children scroll request                                           
            if (component.interactionMode == this.TraversalModes.Horizontal) {
                component.scrollHorizontally(targetElem);
            }
            else {
                if (component.verticalScrollingEnabled) {
                    //internal vertical  scrolling
                    component.requestVerticalScroll(targetElem);
                }
                else {
                    //request page container vertical scrolling
                    this.eventInteraction.next({ key: "verticalScrollingRequested", message: targetElem });
                }
            }
        }
    }

    public handleAsyncDataReload(component, changes) {
        //detects if item data changing, re-focus (only on rows  & columns)
        if (changes.item && !changes.item.firstChange) {
            if ([this.TraversalModes.Horizontal, this.TraversalModes.Vertical].indexOf(component.interactionMode) > -1) {
                if (changes.item.currentValue !== changes.item.previousValue) {
                    this.reinitFocus = true;
                    let tempFocusIndex = component.focusedItemIndex;
                    component.focusedItem = null;
                    setTimeout(() => {
                        this.keyBehavior.focusLinearly(tempFocusIndex, component);
                        this.reinitFocus = false;
                        component.ref.markForCheck();
                    }, 250);
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/ui.state.engine.ts